export const name = "ST_GEOHASH";
export const summary = `Converts a point \`GEOGRAPHY\` value to a \`STRING\` GeoHash value.`;
export const reference = `
## ST_GEOHASH

Converts a point \`GEOGRAPHY\` value to a \`STRING\` GeoHash value.

\`\`\`
ST_GEOHASH(geography_expression[, maxchars])
\`\`\`

### Description

Takes a single-point \`GEOGRAPHY\` and returns a GeoHashrepresentation of that \`GEOGRAPHY\` object.

- \`geography_expression\`: Represents a \`GEOGRAPHY\` object. Only a \`GEOGRAPHY\`object that represents a single point is supported. If \`ST_GEOHASH\` is used over an empty \`GEOGRAPHY\` object, returns \`NULL\`.
- \`maxchars\`: This optional \`INT64\` parameter specifies the maximum number of characters the hash will contain. Fewer characters corresponds to lower precision (or, described differently, to a bigger bounding box). \`maxchars\`defaults to 20 if not explicitly specified. A valid \`maxchars\` value is 1 to 20. Any value below or above is considered unspecified and the default of 20 is used.


### Return type

\`STRING\`


### Example

Returns a GeoHash of the Seattle Center with 10 characters of precision.



\`\`\`
SELECT ST_GEOHASH(ST_GEOGPOINT(-122.35, 47.62), 10) geohash

/*--------------*
 | geohash |
 +--------------+
 | c22yzugqw7 |
 *--------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
